var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"progress__wrapper"},[_c('img',{attrs:{"src":"https://bpcard.ru/images/2.gif","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }